import React from 'react'

import { tag } from './Tag.css'
import clsx from 'clsx'

type TagProps = React.HTMLProps<HTMLDivElement> & {
  type?: 'regular' | 'small' | 'xsmall'
  active?: boolean
  baseColor?: 'grey' | 'white'
  as?: 'div' | 'span'
}

export const Tag = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<TagProps>
>(
  (
    {
      children,
      className = '',
      type = 'regular',
      as = 'span',
      baseColor = 'grey',
      active = false,
      style = {},
      ...rest
    },
    forwardedRef
  ) => {
    const Component = as
    return (
      <Component
        ref={forwardedRef}
        className={clsx([tag, className])}
        data-interactive={!!rest.onClick}
        data-active={active}
        data-base-color={baseColor}
        data-type={type}
        style={style}
        {...rest}
      >
        {children}
      </Component>
    )
  }
)

Tag.displayName = 'Tag'
